import {css} from 'lit';
export const styles = css`:host {
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: var(--contrast-light);
  padding: 32px 32px 16px;
  border-radius: var(--border-radius);
}

button {
  border: none;
  font-size: 24px;
  font-weight: 700;
  color: var(--dark-text-secondary);
  background-color: transparent;
  padding: 4px;
}

button:first-child {
  position: absolute;
  top: 8px;
  right: 8px;
}

.scroll {
  padding: 8px;
  color: var(--primary);
}

.scroll ef-icon {
    font-size: 38px;
  }

slot::slotted(.xs-box) {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
`;
export default styles;
